import React, { useState, useEffect, MouseEvent } from "react";
import "./SimpleNumber.css";

interface SimpleNumberInputProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
}

const SimpleNumberInput: React.FC<SimpleNumberInputProps> = ({
  value,
  onChange,
  min,
  max,
  step,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  const roundValue = (num: number, numStep: number) => {
    if (min !== undefined && num < min) {
      num = min;
    } else if (max !== undefined && num > max) {
      num = max;
    }

    num = Math.round(num / numStep) * numStep;

    return num;
  };

  const handleMinusClick = (event: MouseEvent) => {
    event.stopPropagation();
    const roundedValue = roundValue(inputValue - step, step);
    setInputValue(roundedValue);
    onChange(roundedValue);
  };

  const handlePlusClick = (event: MouseEvent) => {
    event.stopPropagation();
    const roundedValue = roundValue(inputValue + step, step);
    setInputValue(roundedValue);
    onChange(roundedValue);
  };

  const handleInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10) || 0;
    setInputValue(value);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        const roundedValue = roundValue(value, step);
        setInputValue(roundedValue);
        onChange(roundedValue);
      }, 600)
    );
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div className="simple-number-input">
      <button className="simple-number-input__minus" onClick={handleMinusClick}>
        –
      </button>

      <div className="simple-number-input__input">
        <input
          type="number"
          value={inputValue}
          onChange={handleInputValue}
          min={min}
          max={max}
          step={step}
        />
      </div>

      <button className="simple-number-input__plus" onClick={handlePlusClick}>
        +
      </button>
    </div>
  );
};

export default SimpleNumberInput;
